var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2248_119167)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0035 0.869141C12.234 0.869141 12.4551 0.96071 12.6181 1.12371C12.7811 1.28672 12.8726 1.5078 12.8726 1.73832V22.5987C12.8726 22.8292 12.7811 23.0503 12.6181 23.2133C12.4551 23.3763 12.234 23.4679 12.0035 23.4679C11.7729 23.4679 11.5519 23.3763 11.3889 23.2133C11.2259 23.0503 11.1343 22.8292 11.1343 22.5987V1.73832C11.1343 1.5078 11.2259 1.28672 11.3889 1.12371C11.5519 0.96071 11.7729 0.869141 12.0035 0.869141ZM1.57328 11.2993H22.4336C22.6642 11.2993 22.8852 11.3909 23.0483 11.5539C23.2113 11.7169 23.3028 11.938 23.3028 12.1685C23.3028 12.399 23.2113 12.6201 23.0483 12.7831C22.8852 12.9461 22.6642 13.0377 22.4336 13.0377H1.57328C1.34276 13.0377 1.12168 12.9461 0.958674 12.7831C0.795671 12.6201 0.704102 12.399 0.704102 12.1685C0.704102 11.938 0.795671 11.7169 0.958674 11.5539C1.12168 11.3909 1.34276 11.2993 1.57328 11.2993Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2248_119167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5987,
    height: 22.5987,
    fill: "white",
    transform: "translate(0.704102 0.869141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNew);
export default __webpack_public_path__ + "static/media/addNew.431970f234098ca54ad51b926f62e1ff.svg";
export { ForwardRef as ReactComponent };